import { render, staticRenderFns } from "./JobInquiriesPage.vue?vue&type=template&id=3f7a1f94&scoped=true&"
import script from "./JobInquiriesPage.vue?vue&type=script&lang=js&"
export * from "./JobInquiriesPage.vue?vue&type=script&lang=js&"
import style0 from "./JobInquiriesPage.vue?vue&type=style&index=0&id=3f7a1f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a1f94",
  null
  
)

export default component.exports